export const capitalize = (string: string) => (string ? string[0].toUpperCase() + string.substring(1) : string);

export const isAmountWithoutText = (string: string) => string?.match(/^\+[0-9]*\s*$/);

export const toSnakeCase = (string: string) => string.replace(/[A-Z]/g, (letter, offset) => `${offset ? '_' : ''}${letter.toLowerCase()}`);

export const toString = (value: unknown): string => (typeof value === 'object' ? JSON.stringify(value) : `${value}`);

type SelectionMutator = (selection: string) => string;
interface SelectionRange {
	start?: number;
	end?: number;
}

/**
 * Modifies a string of text by passing in the current selection range to a mutating function. Returns
 * the newly created text and the start and end position of the string that was created
 *
 * @param text    The original text
 * @param mutator A function that accepts the selected text within the original and returns the modified text
 * @param config  An object containing the `start` and `end` positions of the selected text
 * @returns
 */
export const morphTextSelection = (text: string, mutator: SelectionMutator, { start = 0, end = 0 }: SelectionRange) => {
	const morphText = mutator(text.slice(start, end));
	const chars = text.split('');

	chars.splice(start, end - start, morphText);

	return {
		updatedText: chars.join(''),
		selectionStart: start,
		selectionEnd: start + morphText.length,
	};
};
